import React from 'react'
import { useTranslation } from '@sailor/i18n-web'
import { Link } from 'react-router-dom'
import {
  HeroContent,
  Title,
  Subtitle,
  CTAButton,
  HeroImage,
} from './styles'
import Container from '../Container/index'
import styles from './index.module.less'
import { getDangerHtmlText } from '@/common/utils'

interface Props {
  title: string
  subtitle: string
  backgroundImage: string
}

const PageSection: React.FC<Props> = (props) => {
  const { t } = useTranslation()

  return (
    <Container style={{ paddingBottom: 0, paddingTop: 0 }} contentClassName={styles.container}>
      <HeroContent>
        <Title dangerouslySetInnerHTML={getDangerHtmlText(props.title)} />
        <Subtitle>{props.subtitle}</Subtitle>
        <CTAButton as={Link} to="/contact" variant="primary">
          {t('ent_o_nav_contact')}
        </CTAButton>
      </HeroContent>
      <HeroImage style={{ backgroundImage: `url(${props.backgroundImage})` }} />
    </Container>
  )
}

export default PageSection